import React, { useEffect, useRef, useState } from 'react';
import { TabView, TabPanel } from 'primereact/tabview';
import { Fieldset } from 'primereact/fieldset';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { setLPDetails, unSet } from '../../slices/createLPSlice';
import { setEdit } from '../../slices/authSlice';
import { LandingPageServe } from '../../services/api/LandingPageServ';
import EmbeddedFileExplorer from '../../components/EmbeddedFileExplorer';

const ViewExternalLP = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const toast = useRef(null);
  const lpDetails = useSelector((state) => state.createLp.data);
  const [activeTab, setActiveTab] = useState(0);

  useEffect(() => {
    const load = async () => {
      try {
        const data = await LandingPageServe.single(id);
        dispatch(setLPDetails(data));
      } catch (e) {
        console.log(e);
      }
    };
    if (!lpDetails._id) load();
    dispatch(setEdit(false));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleArchive = () => {
    confirmDialog({
      message: 'Are you sure you want to archive this LP?',
      header: 'Confirm Archive',
      icon: 'pi pi-exclamation-triangle',
      acceptClassName: 'p-button-danger',
      accept: async () => {
        try {
          await LandingPageServe.update(id, { status: 'archived' });
          toast.current.show({ severity: 'success', summary: 'Archived' });
          dispatch(unSet());
          navigate('../lplist');
        } catch (e) {
          toast.current.show({ severity: 'error', summary: 'Error', detail: e.message });
        }
      }
    });
  };

  const handlePublish = () => {
    confirmDialog({
      message: 'Are you sure you want to publish this LP?',
      header: 'Confirm Publish',
      icon: 'pi pi-cloud-upload',
      accept: async () => {
        try {
          await LandingPageServe.update(id, { status: 'published' });
          toast.current.show({ severity: 'success', summary: 'Published' });
          dispatch(unSet());
          navigate('../lplist');
        } catch (e) {
          toast.current.show({ severity: 'error', summary: 'Error', detail: e.message });
        }
      }
    });
  };

  const lp = lpDetails;

  return (
    <>
      <Toast ref={toast} />
      <ConfirmDialog />
      <div className="card">
        <div className="flex justify-content-between pb-1">
          <span style={{ fontWeight: 700, fontSize: '1.1rem', color: '#334155' }}>{lp.name}</span>
          <div className="flex gap-2">
            <Button icon="pi pi-trash" className="w-2rem h-2rem p-0" severity="danger" rounded outlined tooltip="Archive" tooltipOptions={{ position: 'left' }} onClick={handleArchive} />
            <Button icon="pi pi-cloud-upload" className="w-2rem h-2rem p-0" severity="primary" rounded outlined tooltip="Publish" tooltipOptions={{ position: 'left' }} onClick={handlePublish} />
            <Button icon="pi pi-pencil" className="w-2rem h-2rem p-0" severity="info" rounded outlined tooltip="Edit" tooltipOptions={{ position: 'left' }} onClick={() => navigate(`../edit-external-lp/${id}`)} />
            <Button icon="pi pi-times" className="w-2rem h-2rem p-0" severity="warning" rounded outlined tooltip="Back" tooltipOptions={{ position: 'left' }} onClick={() => { dispatch(unSet()); navigate('../lplist'); }} />
          </div>
        </div>

        <TabView activeIndex={activeTab} onTabChange={e => setActiveTab(e.index)}>
          <TabPanel header="Summary">
            <div className="grid pt-4">
              <div className="col-6 col-offset-3">
                <Fieldset legend="LP Summary">
                  <div className="field">
                    <span className="p-float-label">
                      <InputText value={lp.name || ''} disabled style={{ width: '100%' }} />
                      <label>Name</label>
                    </span>
                  </div>
                  <div className="field">
                    <span className="p-float-label">
                      <InputText value={lp.campaignId || ''} disabled style={{ width: '100%' }} />
                      <label>Campaign ID</label>
                    </span>
                  </div>
                  <div className="field">
                    <span className="p-float-label">
                      <InputText value={lp.campaignName || ''} disabled style={{ width: '100%' }} />
                      <label>Campaign Name</label>
                    </span>
                  </div>
                  <div className="field">
                    <span className="p-float-label">
                      <InputText value={lp.description || ''} disabled style={{ width: '100%' }} />
                      <label>Description</label>
                    </span>
                  </div>
                  <div className="field">
                    <span className="p-float-label">
                      <InputText value={lp.client || ''} disabled style={{ width: '100%' }} />
                      <label>Client</label>
                    </span>
                  </div>
                  <div className="field">
                    <span className="p-float-label">
                      <InputText value={lp.hostingDetails?.domain || ''} disabled style={{ width: '100%' }} />
                      <label>Domain</label>
                    </span>
                  </div>
                  <div className="field">
                    <span className="p-float-label">
                      <InputText value={lp.thumbnail || ''} disabled style={{ width: '100%' }} />
                      <label>Thumbnail</label>
                    </span>
                  </div>
                </Fieldset>
              </div>
            </div>
          </TabPanel>
          <TabPanel header="Files">
            {lp.hostingDetails?.path && lp.campaignId && (
              <EmbeddedFileExplorer
                domain={lp.hostingDetails.path}
                domainLabel={lp.hostingDetails.domain}
                campaignId={lp.campaignId}
                pocId={lp._id}
              />
            )}
          </TabPanel>
        </TabView>
      </div>
    </>
  );
};

export default ViewExternalLP;
